'use client';

import dynamic from 'next/dynamic';

const LazyColorPicker = dynamic(() => import('./ColorPicker'));

export default LazyColorPicker;
